<template>
  <div v-if="file">
    <div
      style="border: 2px solid red; padding: 5px"
      v-if="file.quote && file.quote.cqsnote"
    >
      <div style="font-weight: bold; margin-bottom: 5px">cqs</div>
      <div style="white-space: pre-wrap">{{ file.quote.cqsnote }}</div>
    </div>
    <section-header
      id="fileinformation"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >File information</section-header
    >
    <Boxes v-if="addBox" @close-boxes="openBoxes(false)" @update="update" />
    <Logs v-if="logShow" @close-logs="openLogs(false)" />
    <HeaderRight
      :file="file"
      :logShow="logShow"
      @open-boxes="openBoxes(true)"
      @open-logs="openLogs(true)"
      @update="update"
    />
    <table class="simple">
      <tr>
        <th>Reference</th>
        <td>
          <span :class="`department${file.department.id}`">{{
            file.referencelong
          }}</span>
          <span>&#160;</span>
          <a @click="regenerateReference">regenerate</a>
        </td>
      </tr>
      <tr v-if="related">
        <th>Related</th>
        <td>
          <FileZ :file="related" />
        </td>
      </tr>
      <tr v-if="file.quote">
        <th>Quote</th>
        <td>
          <Quote :quoteId="file.quote.id" />
          <span>&#160;</span>
          <span :class="file.quote.totalClass">{{
            file.quote.total | toCurrency
          }}</span>
        </td>
      </tr>
      <tr>
        <th>Instruction date</th>
        <td>
          {{ file.instructiondate | formatDate }}
          <span class="headerDayCount">{{ instructionDiff }} days ago</span>
        </td>
      </tr>
      <tr>
        <th>Nag date</th>
        <td>
          <span v-if="file.nagdate" :class="nagClass">{{
            file.nagdate | formatDate
          }}</span>
          <span v-if="!file.nagdate">Not set</span>
          <span>&#160;</span>
          <v-dialog v-model="dialogNag" width="500">
            <template v-slot:activator="{ on }">
              <a dark v-on="on">Change</a>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title
                >Change nag date</v-card-title
              >
              <v-card-text
                >Please set the nag date below and click Update</v-card-text
              >
              <v-card-text>
                <v-date-picker v-model="nagDate"></v-date-picker>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click="updateNag">Update</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </td>
      </tr>
      <tr v-if="file.category.id == 2 || file.category.id == 3">
        <th>Mortgage offer expires</th>
        <td>
          <span v-if="file.mortgageofferexpires">{{
            file.mortgageofferexpires | formatDate
          }}</span>
          <span v-if="!file.mortgageofferexpires">Not set</span>
          <span>&#160;</span>
          <v-dialog v-model="dialogMortgageOfferExpires" width="500">
            <template v-slot:activator="{ on }">
              <a dark v-on="on">Change</a>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title
                >Change Mortgage offer expires date</v-card-title
              >
              <v-card-text
                >Please set the Mortgage offer expiry date below and click
                Update</v-card-text
              >
              <v-card-text>
                <v-date-picker v-model="mortgageofferexpires"></v-date-picker>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click="updateMortgageOfferExpires"
                  >Update</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span>&#160;</span>
          <a @click="clearMortgageOfferExpires">Clear</a>
        </td>
      </tr>
      <tr v-if="file.category.id != 4">
        <th>OS1 date</th>
        <td>
          <span v-if="file.os1date" :class="os1Class">{{
            file.os1date | formatDate
          }}</span>
          <span v-if="!file.os1date">Not set</span>
          <span>&#160;</span>
          <v-dialog v-model="dialogOs1" width="500">
            <template v-slot:activator="{ on }">
              <a dark v-on="on">Change</a>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title
                >Change OS1 date</v-card-title
              >
              <v-card-text
                >Please set the OS1 date below and click Update</v-card-text
              >
              <v-card-text>
                <v-date-picker v-model="os1Date"></v-date-picker>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click="updateOs1">Update</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span>&#160;</span>
          <a @click="clearOs1">Clear</a>
        </td>
      </tr>
      <tr>
        <th>Completion date</th>
        <td>
          <span v-if="file.completiondate" :class="completionClass">{{
            file.completiondate | formatDate
          }}</span>
          <span v-if="!file.completiondate">Not set</span>
          <span>&#160;</span>
          <v-dialog v-model="dialogCompletion" width="500">
            <template v-slot:activator="{ on }">
              <a dark v-on="on">Change</a>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title
                >Change completion date</v-card-title
              >
              <v-card-text
                >Please set the completion date below and click
                Update</v-card-text
              >
              <v-card-text>
                <v-date-picker
                  v-model="completionDate"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click="updateCompletion"
                  >Update</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span>&#160;</span>
          <a @click="clearCompletion">Clear</a>
        </td>
      </tr>
      <tr>
        <th>Completion bundle</th>
        <td>
          <v-btn v-if="file.bundleCompletion" @click="downloadLink">
            <v-icon>picture_as_pdf</v-icon>Download
          </v-btn>
          <router-link
            :to="{
              name: 'upload',
              query: {
                objectType: 'file',
                objectId: $route.params.id,
                bundleCompletion: true
              }
            }"
            >Upload</router-link
          >
        </td>
      </tr>
      <tr v-if="file.box">
        <th>Box</th>
        <td>
          <Box :boxId="file.box.id" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import FILE from "@/graphql/file/File";
import UPLOAD_FILE_SIGNED_URL from "@/graphql/document/UploadFileSignedUrl";
import Box from "@/components/link/Box";
import FileZ from "@/components/link/FileZ";
import Quote from "@/components/link/Quote";
import Boxes from "@/components/file/header/Boxes";
import HeaderRight from "@/components/file/header/HeaderRight";
import Logs from "@/components/file/header/Logs";
import SectionHeader from "@/components/file/SectionHeader";
import { parseISO, isSaturday, isSunday } from "date-fns";
import {
  formatDate,
  parseDate,
  daysBetween,
  getDateClass
} from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Header",
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    file: {
      query: FILE,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      error(error) {
        console.error(error);
        this.$router.push({ name: "home" });
      },
      fetchPolicy: "cache-and-network"
    }
  },
  props: ["departmentId", "swiftMove", "related"],
  components: {
    Box,
    FileZ,
    Quote,
    Boxes,
    HeaderRight,
    Logs,
    SectionHeader
  },
  computed: {
    title() {
      const title = this.file ? this.file.referencelong : "File";
      return title;
    }
  },
  data() {
    return {
      instructionDiff: null,
      completionDiff: null,
      nagClass: null,
      os1Class: null,
      mortgageofferexpiresClass: null,
      completionClass: null,
      addBox: false,
      logShow: false,
      nagDate: null,
      completionDate: null,
      mortgageofferexpires: null,
      os1Date: null,
      dialogNag: false,
      dialogCompletion: false,
      dialogMortgageOfferExpires: false,
      dialogOs1: false
    };
  },
  methods: {
    formatDate,
    parseDate,
    async regenerateReference() {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/regenerate`,
        null
      );
      this.update();
    },
    async updateFileDate({ dateName, date }) {
      const iso = parseISO(date);
      if (isSaturday(iso) || isSunday(iso)) {
        if (!confirm("Chosen date falls at weekend.  Are you sure?")) {
          return;
        }
      }
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/${dateName}`,
        { date }
      );
      this.update();
    },
    update() {
      this.$apollo.queries.file.refetch();
    },
    updateNag() {
      this.dialogNag = false;
      this.updateFileDate({
        dateName: "nag",
        date: this.nagDate
      });
    },
    updateCompletion() {
      this.dialogCompletion = false;
      this.updateFileDate({
        dateName: "completion",
        date: this.completionDate
      });
    },
    clearCompletion() {
      this.updateFileDate({
        dateName: "completion",
        date: null
      });
    },
    updateOs1() {
      this.dialogOs1 = false;
      this.updateFileDate({
        dateName: "os1",
        date: this.os1Date
      });
    },
    clearOs1() {
      this.updateFileDate({
        dateName: "os1",
        date: null
      });
    },
    updateMortgageOfferExpires() {
      this.dialogMortgageOfferExpires = false;
      this.updateFileDate({
        dateName: "mortgageofferexpires",
        date: this.mortgageofferexpires
      });
    },
    clearMortgageOfferExpires() {
      this.updateFileDate({
        dateName: "mortgageofferexpires",
        date: null
      });
    },
    async downloadLink() {
      const response = await this.$apollo.query({
        query: UPLOAD_FILE_SIGNED_URL,
        variables: { id: this.file.bundleCompletion.id }
      });
      window.open(response.data.uploadFile.upload.signedUrlGet, "_blank");
    },
    openBoxes(value) {
      this.addBox = value;
    },
    openLogs(value) {
      this.logShow = value;
    }
  },
  watch: {
    file: {
      handler() {
        if (this.file) {
          const now = new Date().toISOString();
          this.$emit("update", this.file.department.id, this.file.swiftMove);
          this.instructionDiff = this.file.instructiondate
            ? daysBetween(now, this.file.instructiondate)
            : null;
          this.nagDate = this.file.nagdate
            ? this.file.nagdate.substr(0, 10)
            : null;
          this.nagClass = this.file.nagdate
            ? getDateClass(daysBetween(now, this.file.nagdate))
            : null;
          this.completionDate = this.file.completiondate
            ? this.file.completiondate.substr(0, 10)
            : null;
          this.completionClass = this.file.completiondate
            ? getDateClass(daysBetween(now, this.file.completiondate))
            : null;
          this.os1Date = this.file.os1date
            ? this.file.os1date.substr(0, 10)
            : null;
          this.os1Class = this.file.os1date
            ? getDateClass(daysBetween(now, this.file.os1date))
            : null;
          this.mortgageofferexpires = this.file.mortgageofferexpires
            ? this.file.mortgageofferexpires.substr(0, 10)
            : null;
          this.mortgageofferexpiresClass = this.file.mortgageofferexpires
            ? getDateClass(daysBetween(this.file.mortgageofferexpires, now))
            : null;
        } else {
          this.instructionDiff = null;
          this.nagDate = null;
          this.nagClass = null;
          this.completionDate = null;
          this.completionClass = null;
          this.os1Date = null;
        }
      }
    }
  }
};
</script>

<style>
</style>
